"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearMarkerAnimation = exports.animateLocationMarker = exports.updateNonBookableMarkers = exports.getNonBookableLocationColor = void 0;
const getNonBookableLocationColor = (theme) => theme.color_text_secondary;
exports.getNonBookableLocationColor = getNonBookableLocationColor;
/**
 * @param {google.maps.markers} markers
 * @param {Array} locations
 */
const updateNonBookableMarkers = (markers, locations, theme) => {
    const nonBookableIds = new Set(locations.map((loc) => loc.id));
    if (nonBookableIds.size) {
        markers.forEach(({ marker, meta }) => {
            if (nonBookableIds.has(meta.location.id)) {
                marker.setIcon(Object.assign(Object.assign({}, marker.getIcon()), { fillOpacity: 1, fillColor: (0, exports.getNonBookableLocationColor)(theme) }));
            }
        });
    }
};
exports.updateNonBookableMarkers = updateNonBookableMarkers;
/**
 * @param {Array<{marker: google.maps.marker, meta: object}>} markers
 * @param {String} locationId
 */
const animateLocationMarker = (markers, locationId) => {
    markers.forEach(({ meta, marker }) => {
        if (!marker.animating && meta.location.id === locationId) {
            meta.startAnimation();
        }
        else if (marker.animating) {
            meta.stopAnimation();
        }
    });
};
exports.animateLocationMarker = animateLocationMarker;
/**
 * @param {Array<{marker: google.maps.marker, meta: object}>} markers
 */
const clearMarkerAnimation = (markers) => {
    markers.forEach(({ meta, marker }) => {
        if (marker.animating) {
            meta.stopAnimation();
        }
    });
};
exports.clearMarkerAnimation = clearMarkerAnimation;
//# sourceMappingURL=ProviderLocations.gmap.utils.js.map